import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import { SRLWrapper } from "simple-react-lightbox";
import Typography from '@material-ui/core/Typography';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { ThemeProvider, useTheme, createMuiTheme } from '@material-ui/core/styles';

function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: "auto",
    height: "auto",
  },
}));
const tileData1 = [
  {
    img: '/images/ns196912e105.jpg',
    thumb: '/images/ns196912e105-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: "1969_12",
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/ns197411k034.jpg',
    thumb: '/images/ns197411k034.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullWidth',
    title: "1974_11",
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/Engagement.jpg',
    thumb: '/images/Engagement-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullWidth',
    title: "1970_06_10 To remember mom's engagement",
    author: 'author',
    cols: 2,
  },
  {
    img: '/images/ns197507k034.jpg',
    thumb: '/images/ns197507k034-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: "1975_07 Yorktown, VA",
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/ns197904k104.jpg',
    thumb: '/images/ns197904k104-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: "1979_04",
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/103-0345_IMG.jpg',
    thumb: '/images/103-0345_IMG-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: "2002_10_16 Parents' resting site",
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/103-0348_IMG.jpg',
    thumb: '/images/103-0348_IMG-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullWidth',
    title: '2002_10_16 Gravestone. Oops! 남석 남혁 not 남석 남훈',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/103-0354_IMG.jpg',
    thumb: '/images/youngdo.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullWidth',
    title: '2002_10_17 With 영도',
    author: 'author',
    cols: 2,
  },
  {
    img: '/images/IMG_2016.jpg',
    thumb: '/images/IMG_2016dj800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03 동준',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2017.jpg',
    thumb: '/images/IMG_2017cmyj800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03 종명 유진',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2013.jpg',
    thumb: '/images/IMG_2013sd800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2020.jpg',
    thumb: '/images/IMG_2020yd800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2025.jpg',
    thumb: '/images/IMG_2025name800.jpg',
    title: '2006_10_03 임종명 임유진 안동준 안혁준',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2022.jpg',
    thumb: '/images/IMG_2022aunt800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2024.jpg',
    thumb: '/images/IMG_2024gift800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2026.jpg',
    thumb: '/images/IMG_2026g1-800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2027.jpg',
    thumb: '/images/IMG_2027g2-800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_2028.jpg',
    thumb: '/images/IMG_2028g3-800.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2006_10_03',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_1995.jpg',
    thumb: '/images/IMG_1995-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: "2006_09_30",
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_1150.jpg',
    thumb: '/images/IMG_1150-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: "2015_03_25 Top of the Mt. Lemmon",
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_3939.jpg',
    thumb: '/images/IMG_3939-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullWidth',
    title: '2019_01_01 With 미영 and 정현 at San Diego',
    author: 'author',
    cols: 2,
  },
  {
    img: '/images/IMG_5530.jpg',
    thumb:'/images/IMG_5530-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2020_11_07 Adam and Brandon',
    author: 'author',
    cols: 1,
  },
  {
    img: '/images/IMG_5591.jpg',
    thumb:'/images/IMG_5591-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullWidth',
    title: '2020_12_28 지니, 에스더 and 브라이언',
    author: 'author',
    cols: 1,
  }
]
const tileData2 = [
  {
    img: '/julia/IMG_0882.jpg',
    thumb: '/Image4SS/IMG_0882-tn.jpg',
    thumbDisplay: 'MuiGridListTile-imgFullWidth',
    smThumbDisplay: 'MuiGridListTile-imgFullHeight',
    title: '2004_04_30',
    author: 'author',
    cols: 2,
    smcols: 2,
  },
  {
   img: '/julia/IMG_0898.jpg',
   thumb: '/Image4SS/IMG_0898-tn.jpg',
   thumbDisplay: 'MuiGridListTile-imgFullHeight',
   smThumbDisplay: 'MuiGridListTile-imgFullHeight',
   title: '2004_05_01',
   author: 'author',
   cols: 1,
   smcols: 1,
 },
 {
   img: '/julia/IMG_0902.jpg',
   thumb: '/Image4SS/IMG_0902-tn.jpg',
   thumbDisplay: 'MuiGridListTile-imgFullHeight',
   smThumbDisplay: 'MuiGridListTile-imgFullHeight',
   title: '2004_05_01',
   author: 'author',
   cols: 1,
   smcols: 1,
 },
 {
   img: '/julia/IMG_0905.jpg',
   thumb: '/Image4SS/IMG_0905-tn.jpg',
   thumbDisplay: 'MuiGridListTile-imgFullHeight',
   smThumbDisplay: 'MuiGridListTile-imgFullHeight',
   title: '2004_05_01',
   author: 'author',
   cols: 1,
   smcols: 2,
 },
 {
   img: '/julia/IMG_0909.jpg',
   thumb: '/Image4SS/IMG_0909-tn.jpg',
   thumbDisplay: 'MuiGridListTile-imgFullWidth',
   smThumbDisplay: 'MuiGridListTile-imgFullWidth',
   title: '2004_05_01',
   author: 'author',
   cols: 2,
   smcols: 2,
 },
 {
   img: '/julia/IMG_0915.jpg',
   thumb: '/Image4SS/IMG_0915-tn.jpg',
   thumbDisplay: 'MuiGridListTile-imgFullHeight',
   smThumbDisplay: 'MuiGridListTile-imgFullHeight',
   title: '2004_05_02',
   author: 'author',
   cols: 1,
   smcols: 2,
 },
 {
   img: '/julia/IMG_0918.jpg',
   thumb: '/Image4SS/IMG_0918-tn.jpg',
   thumbDisplay: 'MuiGridListTile-imgFullWidth',
   smThumbDisplay: 'MuiGridListTile-imgFullHeight',
   title: '2004_05_02',
   author: 'author',
   cols: 2,
   smcols: 2,
 },
 {
  img: '/julia/IMG_0929.jpg',
  thumb: '/Image4SS/IMG_0929-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullHeight',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_02',
  author: 'author',
  cols: 1,
  smcols: 1,
},
{
  img: '/julia/IMG_0933.jpg',
  thumb: '/Image4SS/IMG_0933-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullHeight',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_02',
  author: 'author',
  cols: 1,
  smcols: 1,
},
{
  img: '/julia/IMG_0934auto.jpg',
  thumb: '/Image4SS/IMG_0934-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_02',
  author: 'author',
  cols: 2,
  smcols: 2,
},
{
  img: '/julia/IMG_0950.jpg',
  thumb: '/Image4SS/IMG_0950-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_14',
  author: 'author',
  cols: 2,
  smcols: 2,
},
{
  img: '/julia/IMG_0952.jpg',
  thumb: '/Image4SS/IMG_0952-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullWidth',
  title: '2004_05_14',
  author: 'author',
  cols: 1,
  smcols: 2,
},
{
  img: '/julia/IMG_0955.jpg',
  thumb: '/Image4SS/IMG_0955-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_14',
  author: 'author',
  cols: 2,
  smcols: 2,
},
{
  img: '/julia/IMG_0956.jpg',
  thumb: '/Image4SS/IMG_0956-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_14',
  author: 'author',
  cols: 1,
  smcols: 1,
},
{
  img: '/julia/IMG_0958a.jpg',
  thumb: '/Image4SS/IMG_0958-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_14',
  author: 'author',
  cols: 1,
  smcols: 1,
},
{
  img: '/julia/IMG_0959a.jpg',
  thumb: '/Image4SS/IMG_0959-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_14',
  author: 'author',
  cols: 1,
  smcols: 1,
},
{
  img: '/julia/IMG_0964a.jpg',
  thumb: '/Image4SS/IMG_0964-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullHeight',
  title: '2004_05_14',
  author: 'author',
  cols: 1,
  smcols: 1,
},
{
  img: '/julia/IMG_0965w.jpg',
  thumb: '/Image4SS/IMG_0965-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullWidth',
  title: '2004_05_14',
  author: 'author',
  cols: 1,
  smcols: 2,
},
{
  img: '/julia/IMG_0966w.jpg',
  thumb: '/Image4SS/IMG_0966-tn.jpg',
  thumbDisplay: 'MuiGridListTile-imgFullWidth',
  smThumbDisplay: 'MuiGridListTile-imgFullWidth',
  title: '2004_05_14',
  author: 'author',
  cols: 4,
  smcols: 2,
}
];

const GalleryOne = (props) => {
  const { width } = props;
  const classes = useStyles();
  
  return (
    <SRLWrapper>
      <div className={classes.root}>
      <GridList spacing={8} cellHeight={300} className={classes.gridList} cols={(width === 'sm' || width === 'xs') ? 2 : 4}>
          {tileData1.map((tile) => (
            <GridListTile key={tile.img} cols={tile.cols || 1}>
             <a href={tile.img}>
              <img src={tile.thumb} alt={tile.title} className={tile.thumbDisplay}/>
             </a>
            </GridListTile>
          ))}
        </GridList>
      </div>
    </SRLWrapper>
  );
}

const GalleryTwo = (props) => {
  const { width } = props;
  console.log(width);
  const classes = useStyles();

  return (
    <SRLWrapper> 
      <div className={classes.root}>
      <GridList spacing={8} cellHeight={300} className={classes.gridList} cols={(width === 'xs') ? 2 : 4}>
          {tileData2.map((tile) => (
            <GridListTile key={tile.img} cols={(width === 'xs') ? tile.smcols : tile.cols}>
              <a href={tile.img}>
               <img src={tile.img} alt={tile.title} className={(width === 'xs') ? tile.smThumbDisplay : tile.thumbDisplay}/>
              </a>
            </GridListTile>
          ))}
        </GridList>
      </div>
    </SRLWrapper>
  );
}

const displayGallery = (id) => {
  console.log(id);
  if (id === 1) {
    return <GalleryOne />;
  } else {
    return <GalleryTwo />;
  }
}
const ExampleWithLightbox = (props) => {
  const classes = useStyles();
  const { galleryId, title } = props;
  const width = useWidth();

  return (
    <div>
      <Container maxWidth="lg" className={classes.container}>
      <Typography variant="h5" gutterBottom>{title}</Typography>

      {(galleryId === 1) ? <GalleryOne width={width} /> : <GalleryTwo width={width} />}
      </Container>
    </div>
  );
}

export default ExampleWithLightbox;